<template>
    <div
        class="cabinet"
        :class="{
            'cabinet-supplier': isSupplier,
            'cabinet-adaptive': isRetailer,
            'cabinet-supplier--bg-gray': isCabinetBgGray
        }"
    >
        <component :is="cabinetNav" />
        <div class="cabinet-content">
            <vue-progress-bar></vue-progress-bar>
            <slot></slot>
            <cabinet-footer></cabinet-footer>
        </div>
        <notifications />
    </div>
</template>

<script>
import Vue from 'vue'
import Notifications from 'vue-notification'
import SupplierNav from '@/components/Cabinet/Nav/SupplierNav'
import RetailerNav from '@/components/Cabinet/Nav/RetailerNav'
import CabinetFooter from '@/components/Cabinet/Footer'
import { mapActions, mapGetters } from 'vuex'

Vue.use(Notifications)

export default {
    name: 'CabinetLayout',
    components: {
        CabinetFooter
    },
    computed: {
        ...mapGetters('user', ['isSupplier', 'isRetailer']),
        isCabinetBgGray() {
            return (
                this.$route.name === 'Supplier' ||
                this.$route.name === 'Retailer'
            )
        },
        cabinetNav() {
            return this.isSupplier
                ? SupplierNav
                : this.isRetailer
                ? RetailerNav
                : null
        }
    },
    mounted() {
        window.$('.filter').removeClass('show')
        window.$('.header__menu').attr('data-open', 'close')
        window.$('body').removeClass('noscroll')
    },
    methods: {
        ...mapActions('cart', ['getCart'])
    }
}
</script>
